import EventBus from "../components/event-bus";
import {HTTP} from '../http-common';

//import moment from 'moment';

export const commonMixins = {

    data: () => ({
        roleId : 0,
        activeMenu : '',
    }),
    mounted: function () {
        var self = this;



    },
    created() {

    },
    beforeMount() {

    },

    computed: {
    },

    watch: {
    },

    methods: {
      getAllPermissions: function () {
        var self = this;

        var config = {
            headers: {
                Authorization:"Bearer " + localStorage.getItem("api_token")
            }
        };
        HTTP.get('get-all-permissions', config).
        then(response => {

            EventBus.$emit('all-permissions', false, response.data.content);

        })
            .catch(function (err) {
                if (err.response.status == 0) {
                    self.error = "Remote server can not be reachable";
                } else {
                    //redirect to login page if user not authenticated
                    if (err.response.status == 401) {
                        //clear previous data
                        localStorage.clear();
                        self.$router.push("/");
                    }
                    self.error = err.response.data.message;
                }
                this.catchHandler(err,true);
            });
    },
      getUserRole: function () {
            var self = this;
            var userObj = localStorage.getItem("user_obj");

            if (userObj != null) {
                var userJson = JSON.parse(userObj);
            }

            var fields = {
                user_id: userJson['id'],
            };
            var config = {
                headers: {
                    Authorization:"Bearer " + localStorage.getItem("api_token")
                }
            };
            HTTP.post('get-login-id-role', fields, config).
            then(response => {

                EventBus.$emit('role', false, response.data.content.roles[0].id, response.data.content.roles[0].name);

            })
                .catch(function (err) {
                    if (err.response.status == 0) {
                        self.error = "Remote server can not be reachable";
                    } else {
                        //redirect to login page if user not authenticated
                        if (err.response.status == 401) {
                            //clear previous data
                            localStorage.clear();
                            self.$router.push("/");
                        }
                        self.error = err.response.data.message;
                    }
                    this.catchHandler(err,true);
                });
        },

        getUserPermissions: function () {
            var self = this;
            var userObj = localStorage.getItem("user_obj");

            if (userObj != null) {
                var userJson = JSON.parse(userObj);
            }

            var fields = {
                user_id: userJson['id'],
            };
            var config = {
                headers: {
                    Authorization:"Bearer " + localStorage.getItem("api_token")
                }
            };
            HTTP.post('get-login-id-permissions', fields, config).
            then(response => {
                EventBus.$emit('role', false, response.data.content.user.roles[0].id, response.data.content.user.roles[0].name);
                EventBus.$emit('permissions', false, response.data.content.permissions);

            })
                .catch(function (err) {
                    if (err.response.status == 0) {
                        self.error = "Remote server can not be reachable";
                    } else {
                        //redirect to login page if user not authenticated
                        if (err.response.status == 401) {
                            //clear previous data
                            localStorage.clear();
                            self.$router.push("/");
                        }
                        self.error = err.response.data.message;
                    }
                    this.catchHandler(err,true);
                });
        },
      getRecords: function (serverPage, perPage, totalRecords) {
        serverPage = Number(serverPage);
        perPage = Number(perPage);
        totalRecords = Number(totalRecords);
        var firstLoad = true;
        var firstRecord = 0;
        var lastRecord = 0;

        var page = serverPage;
        for (var i = 1; i <= page; i++) {
            if (firstLoad == true) {
                firstRecord = lastRecord + 1;
                lastRecord = perPage;
                firstLoad = false;
            } else {
                firstRecord = lastRecord + 1;
                lastRecord = (perPage * i);
            }
        }

        if (totalRecords != 0) {
            if (lastRecord > totalRecords) {
                lastRecord = totalRecords;
            }
        } else if (totalRecords == 0) {
            firstRecord = 0;
            lastRecord = 0;
        }
        return firstRecord + " - " + lastRecord;
    },
        getActiveMenu : function () {
            return self.activeMenu;
        },
        setActiveMenu : function (menu) {
            self.activeMenu = menu;
        },
        showLoader: function () {
            $(".loading-container").show();
        },
        hideLoader: function () {
            //setTimeout(function () {
            $(".loading-container").hide();
            //}, 1700);
            /* let windowHeight = $(window).height();
            let headerHeight = $(".navbar-default").outerHeight();
            let contentHeight = $("#page-content-wrapper").outerHeight();
            let footerHeight = $(".admin-footer").outerHeight();
            if ((headerHeight + contentHeight) < windowHeight) {
                $(".admin-footer").css({"margin-top": Math.round(windowHeight - headerHeight - (contentHeight - footerHeight) - 10) + "px"});
            } else {
                $(".admin-footer").removeAttr("style");
            } */
        },
        catchHandler: function (err, callback) {
          var self = this;
          switch (err.response.status) {
            case 0:
              this.showSAlert('Remote server can not be reachable', 'error', callback);
            case 400:
              this.showSAlert(err.response.data.message, 'error', callback);
              break;
            case 401:
              localStorage.clear();
              //this.showSAlert('Unauthorized', 'error', callback);
              self.$router.push("/");
              break;
            case 404:
              this.showSAlert(err.response.data.message, 'error', callback);
              break;
            case 409:
              this.showSAlert(err.response.data.message, 'error', callback);
              break;
          }
        },
        showSAlert: function (message, type, callback) {
          this.$swal.fire(
            message,
            '',
            type
          );
          //callback("message");
        },
        hideShowHeaderFooter: function() {
            $('#main-header').show();
            $('#sidebar-wrapper').show();
            $("#wrapper").removeClass("login-div-full");
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/commonMixins.js